<template>
    <section id="generic-info-drawer" :class="{ 'for-desktop': isModal}" class="x-padding">
        <h5 class="text-center">{{ drawerData.heading }}</h5>
        <p class="text-center" v-html="drawerData.description"></p>
        <div :class="{ 'w-75 mx-auto for-desktop': isModal, 'single-button': isModal && drawerData.buttons.length === 1 }">
            <b-button :block="!isModal" pill :id="`button-generic-info-actions-${btnIndex}`"
                v-for="(button, btnIndex) in drawerData.buttons" :key="`button-generic-info-actions-${btnIndex}`"
                :class="[button.type]" :style="button.btnStyle || {}" @click="button.btnFunc">
                {{ button.label }}
            </b-button>
        </div>
    </section>
</template>
<script>
import { mapState } from 'vuex';
export default {
    props: {
        isModal: {
            type: Boolean,
            default: () => false
        },
        isMobile: {
            type: Boolean,
            default: () => false
        }
    },
    computed: {
        ...mapState("utilityStore", {
            drawerData: (state) => state.drawerData
        })
    }
}
</script>
<style lang="scss" scoped>
#generic-info-drawer {
    padding: 48px 0px 31px;
    &.for-desktop {
        padding-bottom: 20px;
    }
    &.x-padding {
        padding-left: 28px !important;
        padding-right: 28px !important;
    }
    h5 {
        color: #2F3941;
        font-family: 'SKModernistBold', sans-serif;
        font-size: 1.375rem;
        margin-bottom: 24px;
    }
    p {
        font-size: 1rem;
        color: #68737D;
        margin-bottom: 32px;
    }
    button[id^='button-generic-info-actions-'] {
        font-family: 'SKModernistBold', sans-serif;
        font-size: 1rem;
        height: 50px;
        &:not(:last-child) {
            margin-bottom: 12px;
        }
        &:last-child {
            margin-bottom: 34px;
        }
        &.primary {
            background: var(--main-color);
            border: 0;
            color: var(--button-text-color);
        }
        &.secondary {
            background: transparent;
            border: solid 1px #87929D;
            color: #87929D;
        }
    }
    .for-desktop {
        display: flex;
        gap: 16px;
        button[id^='button-generic-info-actions-'] {
            width: 183px;
            height: 44px;
            margin-bottom: 0;
        }
        &.single-button button[id^='button-generic-info-actions-'] {
            width: 100%;
        }
    }
}
</style>
